import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MasterSummaryPDModel, MasterSummaryQuestionModel, SimpleSurveyQuestion} from '../../../../models/survey/survey.model';
import {SummaryFilterModel, SurveyVersionModelCore} from '../../../../models/summary/summary.model';
import { SortType } from '../../../../shared/constants/sort.constants';

@Component({
  selector: 'app-combined-version',
  templateUrl: './combined-version.component.html',
  styleUrls: ['./combined-version.component.less']
})
export class CombinedVersionComponent implements OnInit, AfterViewInit {

  questionValue: MasterSummaryQuestionModel;
  showUnhideDialog = false;
  unhideQuestionId: number;

  @Input() index: number;

  @Input()
  get question(): MasterSummaryQuestionModel {
    return this.questionValue;
  }

  set question(val) {
    this.questionValue = val;
    this.chartModeSelect = this.questionValue.chartModeSelect;
  }

  @Input() listSurveyVersion: SurveyVersionModelCore[];

  listSimpleSurveyQuestionValue: SimpleSurveyQuestion[] = [];

  @Input() summaryFilterModel: SummaryFilterModel;

  @Input() surveyId: number;

  loader = false;
  id: number = null;
  totalResponse = 0;
  chartModeSelect: string;
  init = false;

  @Output() onHideQuestion: EventEmitter<number> = new EventEmitter<number>();

  @Output() onChangeQuestionSetting: EventEmitter<MasterSummaryPDModel> = new EventEmitter<MasterSummaryPDModel>();  

  constructor() {
  }

  ngOnInit() {
    this.question.listAnswerModel.forEach(answer => {
      this.totalResponse += answer.answerCount;
    });
  }

  ngAfterViewInit(): void {
      this.init = true;
  }

  chartModeSelected(chartModeSelected: any) {
    if (this.init) {
        this.chartModeSelect = chartModeSelected.chartMode;
        this.question.chartModeSelect = this.chartModeSelect;
        this.changeQuestionSetting();
    }
  }

  sortModeSelected(sortModeSelected: any): void {
    if (this.init) {
        this.question.sortModeSelect = sortModeSelected._sortType;
        this.changeQuestionSetting();
    }
  }

  themeModeSelected(themeModeSelected: boolean): void {
    if (this.init) {
        this.question.themeModeSelect = !themeModeSelected;
        this.question.themeModeSelectChanged = true;
        this.question.sortModeSelect = SortType.RESET;
        this.changeQuestionSetting();
    }
  }

  hideQuestion(id: number) {
    this.showUnhideDialog = true;
    this.unhideQuestionId = id;
  }

  hide() {
    if (this.unhideQuestionId) {
      this.onHideQuestion.emit(this.unhideQuestionId);
    }
    this.unhideQuestionId = null;
    this.showUnhideDialog = false;
  }

  private changeQuestionSetting() : void {
      const masterSummaryPDModel = new MasterSummaryPDModel();
      masterSummaryPDModel.listQuestionModel = [this.question];
      masterSummaryPDModel.listSurveyCutQuestion = [];
      masterSummaryPDModel.listSurveyVersionQuestion = [];
      this.onChangeQuestionSetting.emit(masterSummaryPDModel);
  }
}





// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/combined-version/combined-version.component.ts